import { render, staticRenderFns } from "./PercentColorChip.vue?vue&type=template&id=dc18b3fe"
import script from "./PercentColorChip.vue?vue&type=script&lang=js"
export * from "./PercentColorChip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports